import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';

import { EDIT_ROLE_FAILURE, EDIT_ROLE_REQUEST, EDIT_ROLE_SUCCESS } from './editRole.types';

const ATAG = 'addRole';
const L = logger('editRole');

const editRole = L.wrap('()', ({ salonId, roleId, roleName }) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint({ pinSafe: true }),
    ...jsonEndpoint(H.put, `services/v1/salon/${salonId}/role/${roleId}/`, { name: roleName }),
    types: [EDIT_ROLE_REQUEST, EDIT_ROLE_SUCCESS, EDIT_ROLE_FAILURE],
    params: { roleId, salonId, roleName },
  },
}));

// noinspection JSUnusedGlobalSymbols
export default editRole;
